<template>
<div class="RefundList bgc padding-20">
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="待退款" name="0">
            <refundListItem ref="refundList0" @getList="_refresh"></refundListItem>
        </el-tab-pane>
        <el-tab-pane label="已退款" name="1">
            <refundListItem ref="refundList1" @getList="_refresh"></refundListItem>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import RefundListItem from 'views/brandBusiness/activityMgt/refund/components/refundList.vue'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'BBRefundList',
    data() {
        return {
            activeName: '0'
        }
    },
    mounted() {
        if (!this.isRefresh) {
            this.$nextTick(() => {
                this.$refs['refundList' + this.activeName].getList(this.activeName)
            })
        }
    },
    activated() {
        if (this.isRefresh) {
            if (this.isRefresh === 2) {
                this.activeName = '0'
                this.$refs['refundList0'].initParam()
                this.$refs['refundList1'].initParam()
                this.$refs['refundList' + this.activeName].getList(this.activeName)
            } else {
                this._refresh()
            }
            this.setIsRefresh(0)
        }
    },
    methods: {
        handleClick() {
            this.$refs['refundList' + this.activeName].getList(this.activeName)
        },
        _refresh() {
            this.$refs['refundList0']._refresh('0')
            this.$refs['refundList1']._refresh('1')
        },
        ...mapActions(['setIsRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['isRefresh'])
    },
    components: {
        RefundListItem
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.RefundList {
}
</style>
